import React from 'react'
import { Button } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm'
import { useParams } from 'react-router-dom'
import { convertToFormData, sweetAlert } from '../../../utils'
import { useSaveApplicationMutation } from '../../../redux/services/ApplicationService'
import { responseError } from '../../../helpers/responseHandler'

const StepThree = ({ setActiveStep, params, isEdit, setIsEdit }) => {
  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm()
  const [editRequest, { isLoading: editLoading }] = useSaveApplicationMutation()

  const onSubmit = async data => {
    const newForm = convertToFormData({ step_no: '4', ...data })
    setIsEdit(prev => {
      return { ...prev, ...newForm }
    })
    await editRequest({ params, newForm })
      .unwrap()
      .then(res => {
        setActiveStep(3)
        if (res?.status) {
          sweetAlert(res?.message, 'success')
        }
        // if (res?.errors) {
        //     Object.entries(res?.errors)?.forEach(([key, value]) => {
        //         sweetAlert(value[0], 'error')
        //     })
        // }
      })
      .catch(err => {
        responseError(err)
      })
  }

  return (
    <>
      <div className='row justify-content-center'>
        {console.log(isEdit, 'isEdit')}
        <div className='col-xl-9'>
          <div className='card custom-card'>
            <div className='card-body'>
              <h5 className='text-center'>Drug Test Information</h5>
              <div className='row'>
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  className='col-md-12'
                  id='application-status'
                >
                  <div className='row'>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Date of Last Drug Test (Optional)</Form.Label>
                        <Controller
                          name='last_drug_test'
                          control={control}
                          defaultValue={isEdit?.last_drug_test || ''}
                          rules={{
                            required: false,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='date'
                              placeholder='Enter Date of Last Drug Test'
                              isInvalid={errors.last_drug_test}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Drug Test Result (Optional)</Form.Label>
                        <Controller
                          name='drug_test_result'
                          control={control}
                          defaultValue={isEdit?.drug_test_result || ''}
                          rules={{
                            required: false,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='text'
                              placeholder='Enter Drug Test Result'
                              isInvalid={errors.drug_test_result}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Drug Test Provider Name (Optional)</Form.Label>
                        <Controller
                          name='drug_test_provider_name'
                          control={control}
                          defaultValue={isEdit?.drug_test_provider_name || ''}
                          rules={{
                            required: false,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='text'
                              placeholder='Enter Drug Test Provider Name'
                              isInvalid={errors.drug_test_provider_name}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Facility Contact Information (Optional)</Form.Label>
                        <Controller
                          name='facility_contact'
                          control={control}
                          defaultValue={isEdit?.facility_contact || ''}
                          rules={{
                            required: false,
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='text'
                              placeholder='Enter Facility Contact Information'
                              isInvalid={errors.facility_contact}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Upload Drug Test Result:</Form.Label>
                        <Controller
                          name='drug_test_result_file'
                          control={control}
                          defaultValue={''}
                          rules={{
                            required: isEdit?.mvr_report ? false : true,
                            validate: {
                              fileSize: file => {
                                if (!file) return true // allow empty if not required
                                return (
                                  file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB'
                                )
                              },
                              fileType: file => {
                                if (!file) return true // skip if not required
                                const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf']
                                return (
                                  allowedTypes.includes(file.type) ||
                                  'Only JPEG, PNG, or PDF files are allowed'
                                )
                              },
                            },
                          }}
                          render={({ field }) => (
                            <>
                              <Form.Control
                                type='file'
                                onChange={e => field.onChange(e.target.files[0])}
                                isInvalid={errors.mvr_report}
                              />
                              {errors.mvr_report && (
                                <Form.Control.Feedback type='invalid'>
                                  {errors.mvr_report.message}
                                </Form.Control.Feedback>
                              )}
                            </>
                          )}
                        />
                        {isEdit?.mvr_report_url ? (
                          <p>
                            <a
                              href={isEdit?.mvr_report_url}
                              target='_blank'
                              className='text-primary my-1'
                            >
                              View Upload File
                            </a>
                          </p>
                        ) : (
                          '-'
                        )}
                      </Form.Group>
                    </div>
                    {/* <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Link to Government Clearinghouse (Optional)</Form.Label>
                                                <Controller
                                                    name='link_to_government_clearinghouse'
                                                    control={control}
                                                    defaultValue={isEdit?.link_to_government_clearinghouse || ''}
                                                    rules={{
                                                        required: true
                                                    }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            {...field}
                                                            type="url" placeholder="Enter Link to Government Clearinghouse"
                                                            isInvalid={errors.link_to_government_clearinghouse}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div> */}
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label htmlFor='result_submission'>
                          Consent for Drug Test Result Submission (Optional)
                        </Form.Label>
                        <Controller
                          name='drug_test_result_submission'
                          control={control}
                          defaultValue={isEdit?.drug_test_result_submission || false}
                          rules={{
                            required: false,
                          }}
                          render={({ field }) => (
                            <Form.Check
                              {...field}
                              defaultChecked={field.value}
                              id='result_submission'
                              label='I give consent for drug test result submission'
                              isInvalid={errors.drug_test_result_submission}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Form>
                <div className='col-lg-3 d-flex mb-3'>
                  <Button
                    variant='secondary'
                    className='mt-auto w-100'
                    onClick={() => setActiveStep(1)}
                  >
                    Previous
                  </Button>
                </div>
                {/* <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(3)}
                                    >
                                        Next
                                    </Button>
                                </div> */}
                <div className='col-lg-3 d-flex mb-3'>
                  <LoadingButtonWithForm
                    isLoading={editLoading}
                    name='Next & Save'
                    form='application-status'
                    className='text-white mt-auto w-100'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StepThree
